import React from 'react';
import NFTMarketPlace from '../sectionBlocks/NFTMarket';
import Award from "../sectionBlocks/Awards";
import Footer from "../sectionBlocks/Footer";
import {Helmet} from "react-helmet";

function PicturesPeople({data, loading, error, localData}) {
  return (
    <>
      <Helmet>
        <title>PopBelly NFT Pictures · People</title>
      </Helmet>
      <div style={{minHeight: "200px"}}/>
      <NFTMarketPlace 
        displayCollectionName = {``} 
        collectionName = {`People NFT pictures PopBeLLy Collection`} 
        displayPagination = {``} 
        displayLink = {`dn`} 
        linkAddress = {``} 
        linkTitle = {``} 
        fetchingCardsRule = {({meta}) => meta.content[1] === undefined && meta.attributes[0].value === "People"}
        sliceStart = {0}
        loading = {loading} 
        error = {error} 
        data = {data} 
        localData = {localData}
      />
      <Award/>
      <Footer/>
    </>
  );
}

export default PicturesPeople;
